import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import request from '@/router/axios';
import { pageUrls } from '@/components/app-page-select//pageUrls';
import * as shopinfo from '@/api/mall/shopinfo';
import * as goodsspu from '@/api/mall/goodsspu';
import * as bargaininfo from '@/api/mall/bargaininfo';
import * as grouponinfo from '@/api/mall/grouponinfo';
import * as seckillinfo from '@/api/mall/seckillinfo';
import * as articleinfo from '@/api/mall/articleinfo';
export default {
  props: {
    page: [String],
    shopId: [String]
  },
  watch: {
    shopId: function shopId(val, oldVal) {
      if (val != oldVal) {}
    },
    page: function page(val, oldVal) {
      if (val != oldVal) {
        this.initPage();
      }
    }
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      pageUrls: JSON.parse(JSON.stringify(pageUrls)),
      //app 页面地址
      curType: '',
      pageTemp: '',
      //临时展示的url
      shopDisabled: true,
      spuDisabled: true,
      isArticleInfo: false,
      // 文章 pages/article/article-info/index'
      articleInfoList: [],
      // 文章列表
      shopList: [],
      // 店铺列表
      spuList: [],
      // 店铺的商品列表
      form: {
        page: '',
        pageType: '',
        shopId: '',
        spuId: '',
        articleInfoId: ''
      }
    };
  },
  created: function created() {
    this.initPage();
    this.getShopList(); // 加载所有店铺数据
    if (this.shopId) {
      // 特殊处理，如果是店铺的页面就去掉非店铺的页面
      var temp = [];
      this.pageUrls.pages.map(function (item) {
        if (item.shopShow) {
          if (item.shopList && item.url.indexOf('shopId') == -1) {
            //如果是店铺装修且是列表
            item.url = item.url + '?shopId=';
          }
          temp.push(item);
        }
      });
      this.pageUrls.pages = temp;
      this.form.shopId = this.shopId;
    }
  },
  methods: {
    initPage: function initPage() {
      var _this = this;
      if (this.page) {
        var pageTemp = JSON.parse(JSON.stringify(this.page));
        this.pageTemp = pageTemp;
        if (this.page.indexOf('http') != -1) {
          pageTemp = pageTemp.substring(this.page.indexOf('/pages/'), this.page.length);
        }
        var appIdIndex = pageTemp.indexOf('app_id');
        if (appIdIndex != -1) {
          pageTemp = pageTemp.substring(0, appIdIndex - 1);
        }
        if (pageTemp.indexOf('id') != -1) {
          //表示是详情页
          var urlTemp = pageTemp.substring(0, pageTemp.indexOf('id=') + 3);
          var idTemp = pageTemp.substring(pageTemp.indexOf('id=') + 3, pageTemp.length);
          this.form.page = urlTemp;
          if (this.page.indexOf('/pages/shop/shop-detail/index?id=') != -1) {
            //如果是店铺详情页，那么就把选择商品禁用
            this.form.shopId = idTemp;
            this.shopDisabled = false;
            this.spuDisabled = true;
            this.curType = this.pageUrls.types.shopDetailPage;
          } else {
            this.form.spuId = idTemp;
            this.pageUrls.pages.forEach(function (item, index) {
              if (item.url == urlTemp) {
                //判断url类型
                _this.curType = item.type;
                return; //跳出循环
              }
            });

            if (idTemp) {
              if (this.curType == this.pageUrls.types.bargainDetailPage) {
                //如果是 砍价详情页面 取砍价的商品列表
                this.getBargaininfoDetail(idTemp);
              } else if (this.curType == this.pageUrls.types.grouponDetailPage) {
                //如果是 拼团活动详情
                this.getGrouponinfoDetail(idTemp);
              } else if (this.curType == this.pageUrls.types.goodsDetailPage) {
                //如果是 商品详情
                this.getGoodsSpuDetail(idTemp);
              } else if (this.curType == this.pageUrls.types.seckillDetailPage) {
                //如果是 秒杀 详情
                this.getSeckillDetail(idTemp);
              }
            }
            this.shopDisabled = false;
            this.spuDisabled = false;
          }
        } else {
          this.shopDisabled = true;
          this.spuDisabled = true;
          if (this.shopId) {
            // this.form.page = pageTemp.substring(0, pageTemp.indexOf('shopId=') + 7);
          } else {
            this.form.page = pageTemp;
          }
        }
      }
    },
    setPagePath: function setPagePath(url) {
      this.pageTemp = url;
    },
    handleSubmit: function handleSubmit() {},
    onChangePage: function onChangePage(value) {
      var _this2 = this;
      var shopUrl = '';
      if (value) {
        this.form.shopId = '';
        this.form.spuId = '';
        this.form.articleInfoId = '';
        if (value == '/pages/article/article-info/index?id=') {
          //文章单独判断
          this.isArticleInfo = true;
          if (this.articleInfoList.length == 0) {
            articleinfo.getPage({}).then(function (response) {
              _this2.articleInfoList = response.data.data.records;
            }).catch(function () {});
          }
        } else {
          this.isArticleInfo = false;
          this.pageUrls.pages.forEach(function (item, index) {
            if (item.url == value) {
              //判断url类型
              _this2.curType = item.type;
              if (item.type != _this2.pageUrls.types.singlePage) {
                //如果不是单页面，就表示可以选店铺
                _this2.shopDisabled = false;
                if (item.type != _this2.pageUrls.types.shopDetailPage) {
                  //如果不是店铺详情就可以选商品
                  _this2.spuDisabled = false;
                } else {
                  _this2.spuDisabled = true;
                }
              } else {
                _this2.shopDisabled = true;
                _this2.spuDisabled = true;
              }
              if (item.shopList) {
                shopUrl = value + _this2.shopId;
              }
              return;
            }
          });
        }
        if (this.shopId) {
          if (shopUrl) {
            this.pageTemp = shopUrl;
          } else {
            this.pageTemp = value;
          }
          this.form.shopId = this.shopId;
          this.onChangeShop(this.shopId, false);
        } else {
          this.pageTemp = value;
          this.$emit('change', this.pageTemp);
        }
      }
    },
    onChangeShop: function onChangeShop(value, changeShopPage) {
      //更改店铺页面
      if (value) {
        this.form.spuId = '';
        if (changeShopPage) {
          this.pageTemp = this.form.page + this.form.spuId;
        }
        if (this.curType != this.pageUrls.types.shopDetailPage) {
          if (this.curType == this.pageUrls.types.bargainDetailPage) {
            //如果是 砍价详情页面 取砍价的商品列表
            this.getBargaininfo();
          } else if (this.curType == this.pageUrls.types.grouponDetailPage) {
            //如果是 拼团活动详情
            this.getGrouponinfo();
          } else if (this.curType == this.pageUrls.types.seckillDetailPage) {
            //如果是 秒杀 详情
            this.getSeckillinfo();
          } else if (this.curType == this.pageUrls.types.goodsDetailPage) {
            //如果是 商品详情
            this.getGoodsSpu();
          }
        } else {
          //如果是店铺
          this.pageTemp = this.form.page + this.form.shopId;
        }
        this.$emit('change', this.pageTemp);
      }
    },
    onChangeSpu: function onChangeSpu(value) {
      //更改店铺商品
      if (value) {
        this.pageTemp = this.form.page + this.form.spuId;
        this.$emit('change', this.pageTemp);
      }
    },
    onChangeArticle: function onChangeArticle(value) {
      //文章
      if (value) {
        this.pageTemp = this.form.page + this.form.articleInfoId;
        this.$emit('change', this.pageTemp);
      }
    },
    getBargaininfo: function getBargaininfo() {
      var _this3 = this;
      //获取店铺所有 砍价的商品
      bargaininfo.getPage({
        shopId: this.form.shopId
      }).then(function (response) {
        _this3.spuList = response.data.data.records;
      }).catch(function () {});
    },
    getGrouponinfo: function getGrouponinfo() {
      var _this4 = this;
      //获取店铺所有 拼团的商品
      grouponinfo.getPage({
        shopId: this.form.shopId
      }).then(function (response) {
        _this4.spuList = response.data.data.records;
      }).catch(function () {});
    },
    getSeckillinfo: function getSeckillinfo() {
      var _this5 = this;
      //获取店铺所有 秒杀 的商品
      seckillinfo.getPage({
        shopId: this.form.shopId
      }).then(function (response) {
        _this5.spuList = response.data.data.records;
      }).catch(function () {});
    },
    getGoodsSku: function getGoodsSku() {//获取店铺所有商品的规格
      // goodsSku.getPage({shopId:this.form.spuId}).then(response => {
      //   this.skuList = response.data.data.records
      // }).catch(() => {
      // })
    },
    getBargaininfoDetail: function getBargaininfoDetail(id) {
      var _this6 = this;
      //获取 砍价的商品详情,用于回显
      bargaininfo.getObj(id).then(function (response) {
        if (response.data) {
          _this6.form.shopId = response.data.data.shopId;
          _this6.getBargaininfo();
        }
      }).catch(function () {});
    },
    getGrouponinfoDetail: function getGrouponinfoDetail(id) {
      var _this7 = this;
      //获取店铺所有 拼团的商品详情，用于回显
      grouponinfo.getObj(id).then(function (response) {
        if (response.data) {
          _this7.form.shopId = response.data.data.shopId;
          _this7.getGrouponinfo();
        }
      }).catch(function () {});
    },
    getGoodsSpuDetail: function getGoodsSpuDetail(id) {
      var _this8 = this;
      //获取商品详情，用于回显
      goodsspu.getObj(id).then(function (response) {
        if (response.data) {
          _this8.form.shopId = response.data.data.shopId;
          _this8.getGoodsSpu();
        }
      }).catch(function () {});
    },
    getSeckillDetail: function getSeckillDetail(id) {
      var _this9 = this;
      //获取 秒杀 详情，用于回显
      seckillinfo.getObj(id).then(function (response) {
        if (response.data) {
          _this9.form.shopId = response.data.data.shopId;
          _this9.getSeckillinfo();
        }
      }).catch(function () {});
    },
    getGoodsSpu: function getGoodsSpu() {
      var _this10 = this;
      //获取店铺所有商品
      request({
        url: '/mall/goodsspu/list?shopId=' + this.form.shopId,
        method: 'get',
        params: {}
      }).then(function (response) {
        _this10.spuList = response.data;
      }).catch(function () {});
    },
    getShopList: function getShopList() {
      var _this11 = this;
      //获取所有店铺
      shopinfo.getList({}).then(function (response) {
        _this11.shopList = response.data.data;
      }).catch(function () {});
    }
  }
};